"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "bytes/5.0.1";
